// Query string parametrelerini encode ve decode etmek için yardımcı fonksiyonlar
// Basit tipler (string, number, boolean, Date) desteklenir

export const encodeQueryStringParams = (params) => {
  if (!params || typeof params !== "object") return "";

  // JSON stringify ve encodeURIComponent
  const encoded = encodeURIComponent(JSON.stringify(params));

  return `?data=${encoded}`;
};

/**
 * Decode the query string parameter into an object
 * Automatically parses ISO date strings into Date objects
 * @param {string} search - location.search
 * @returns {object} - decoded query params object with Date objects
 */
export const decodeQueryStringParams = (search) => {
  const searchParams = new URLSearchParams(search);
  const encoded = searchParams.get("data");

  if (!encoded) return {};

  try {
    const decoded = decodeURIComponent(encoded);
    const obj = JSON.parse(decoded);

    // Tarihleri string olarak bırakıyoruz → backend’e direkt gönderebilirsin
    return obj;
  } catch (error) {
    console.error("Failed to decode query string:", error);
    return {};
  }
};
